define(['lodash'], function (_) {
    'use strict';

    function mapInAlphabeticalOrder(sourceObj, func, context) {
        const boundFunc = context ? _.bind(func, context) : func;
        const orderedKeys = _.keys(sourceObj).sort();
        const orderedObj = _.reduce(orderedKeys, function (obj, key) {
            obj[key] = sourceObj[key];
            return obj;
        }, {});

        return _.map(orderedObj, boundFunc);
    }

    function noAppsOnSite(siteData) {
        return _.isEmpty(siteData.pagesPlatformApplications); // User only opened platform-dev-tools
    }

    function hasPlatformAppOnRenderedRoots(siteData, rootIds) {
        rootIds = rootIds.concat('masterPage');
        const pagesPlatformApplications = siteData.pagesPlatformApplications;
        return _.some(pagesPlatformApplications, function (app) { // At least one rendered root has an app
            const rootIdsWithApp = _.keys(app);
            return _.some(rootIds, function (rootId) { return _.includes(rootIdsWithApp, rootId); });
        });
    }

    return {
        mapInAlphabeticalOrder,
        noAppsOnSite,
        hasPlatformAppOnRenderedRoots
    };
});
